import { Spacer } from "@faire/web/slate/spacing";
import { useViewport } from "@faire/web/ui/hooks/useViewport";
import * as React from "react";
import styled from "styled-components";

import { NewsModule } from "@faire/retailer/components/NewsModule/NewsModule";

export const NewsSection: React.FC = () => {
  const { isMobile } = useViewport();
  return (
    <>
      <Spacer height={isMobile ? 0 : "2x"} />
      <CenteredNews eventPrefix="faire-direct-sign-up/landing-page/news/" />
    </>
  );
};

const CenteredNews = styled(NewsModule)`
  margin: 0 auto;
`;
